export default "__VITE_ASSET__DK63EzYl__"